// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.loginButton button {
  background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);
  color: #fff;
  border-radius: 0 !important;
  width: 110px;
}

.loginButton button:hover {
  background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);
}

.loginFormContainer .MuiBox-root{
  border-radius: 0;
  background-color: #0C0B13;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{
  color: #666666 !important;
  background: #919191 !important;
  border: 1px solid #999999 !important;

}

.loginFormContainer .MuiInputBase-root input{
  background-color: #222426 !important;
  padding: 3px;
  color: #fff;
}

.loginFormContainer .MuiInputBase-root input:focus-visible{
  background-color: red !important;
}

`, "",{"version":3,"sources":["webpack://./src/components/Login/login.css"],"names":[],"mappings":";;AAEA;EACE,iFAAiF;EACjF,WAAW;EACX,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;;AAEtC;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":["\n\n.loginButton button {\n  background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);\n  color: #fff;\n  border-radius: 0 !important;\n  width: 110px;\n}\n\n.loginButton button:hover {\n  background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);\n}\n\n.loginFormContainer .MuiBox-root{\n  border-radius: 0;\n  background-color: #0C0B13;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{\n  color: #666666 !important;\n  background: #919191 !important;\n  border: 1px solid #999999 !important;\n\n}\n\n.loginFormContainer .MuiInputBase-root input{\n  background-color: #222426 !important;\n  padding: 3px;\n  color: #fff;\n}\n\n.loginFormContainer .MuiInputBase-root input:focus-visible{\n  background-color: red !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
